'use strict'

import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
Vue.prototype.$qs = qs
// import {
//   jkGetSign
// } from '@/util/utils'
import { Message, MessageBox } from 'element-ui'
// Full config:  https://github.com/axios/axios#request-config
//axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.baseURL="/jkyun/"
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  // baseURL : 'http://192.168.88.243:31025/'
  //baseURL : 'http://192.168.4.53:16000/'
}

const _axios = axios.create(config);


axios.interceptors.request.use(
  config => {
    config.headers['cookiey'] = 'e10adc3949ba59abbe56e057f20f883e';
    // config.headers['mem_id'] = '45';
    // config.headers['user_id'] = '444694285270129792';//全员工作组权限
    // config.headers['mem_name'] = 'jackyun_dev';
    // // Do something before request is sent
    // config.data = jkGetSign(config.data);
    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    // Do something with response data
    if (response.status === 200) {
      let res = response.data;
      // if (res.code === 0) {
      //     Message({
      //         showClose: true,
      //         message: res.msg,
      //         type: 'error'
      //     });
      // }
      if (res.code !== 200) {
        if (!res.subCode) {
          // 防止subCode为null报错
          data.subCode = '';
        }
        var sc = res.subCode.split('');
        if (sc[5] * 1 > 3) {
          MessageBox.alert(response.data.msg, '警告', {
            confirmButtonText: '确定',
            type: 'error',
          })
          // res.state = 'danger';
        } else if (sc[5] * 1 == 3) {
          MessageBox.alert(response.data.msg, '警告', {
            confirmButtonText: '确定',
            type: 'error',
          })
          // res.state = 'danger';
          delete res['rsp']['url'];
        } else {
          MessageBox.alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            type: 'warning',
          })
        }
      }
      return Promise.resolve(response);
    } else {
      Message({
        showClose: true,
        message: response.data.msg,
        type: 'success'
      });
      return Promise.reject(response);
    }
    // return response
  },
  error => {
    // Do something with response error
    if (error.response.status) {
      switch (error.response.status) {
        case 404:
          Message({
            showClose: true,
            message: "网络请求不存在",
            type: 'error'
          });
          break;
        default:
          Message({
            showClose: true,
            message: error.response.data.msg,
            type: 'error'
          })
      }
    }
    return Promise.reject(error)
  }
)

export function fetchGet(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params.params
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}


export function fetchPost(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, qs.stringify(data))
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js